import styled from '@emotion/styled'

export const Spinner = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid ${(props: any) => props.theme.colors.borderColor};
  border-top-color: ${(props: any) => props.theme.colors.primary};
  border-radius: 50%;
  animation: category-form-spin 0.7s linear infinite;

  @keyframes category-form-spin {
    to {
      transform: rotate(360deg);
    }
  }
`
